import { render, staticRenderFns } from "./AttachmentDemande.vue?vue&type=template&id=f22c5e98&scoped=true"
import script from "./AttachmentDemande.vue?vue&type=script&lang=js"
export * from "./AttachmentDemande.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDemande.vue?vue&type=style&index=0&id=f22c5e98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c5e98",
  null
  
)

export default component.exports